import { ComponentType, IConfig } from '../../types';
import { BASIC_TANSLATE_TOOLTIP, ComponentConfigType } from '../../utils';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FolderPreview,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: { type: 'Switch' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'flatData',
          label: 'Flat Data',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'height',
          label: 'Height',
          valueComponent: { type: 'InputNumber' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'emptyStateText',
          label: 'Empty State Text',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'modelInstanceId',
          label: 'Model Instance ID',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'downloadButtonText',
          label: 'Download Button Text',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'previewButtonNotAvailableText',
          label: 'Preview Not Available Text',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
